import { useGetResourceLabel, useResourceContext, useTranslate } from 'ra-core';
import { Create, type CreateProps } from '../../components/admin/create';
import { MoonstarTitle } from './MoonstarTitle';

export type MoonstarCreateProps = Omit<CreateProps, 'disableBreadcrumb'>;

/** Kit `Create` with the `[resource label, "Create"]` breadcrumb in the header. */
export const MoonstarCreate = ({ children, ...props }: MoonstarCreateProps) => {
  const resource = useResourceContext(props);
  const getLabel = useGetResourceLabel();
  const translate = useTranslate();

  const label = getLabel(resource!, 1);
  const create = translate('ra.action.create');

  return (
    <>
      <MoonstarTitle breadcrumb={[label, create]} />
      <Create {...props} disableBreadcrumb>
        {children}
      </Create>
    </>
  );
};
